var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "form-page px-md-5" },
    [
      _vm.loading.segments
        ? _c("segments-header-loader")
        : _c("segment-header", {
            attrs: {
              title: _vm.currentList.name,
              "list-id": _vm.listId,
              "current-tab": _vm.currentTab,
              "current-segment": _vm.currentSegment,
            },
            on: {
              "segment-change": _vm.handleChangeTabRequest,
              "delete-contacts": _vm.handleDeleteContacts,
              "delete-current-segment": _vm.handleDeleteCurrentSegment,
            },
          }),
      _vm._v(" "),
      _vm.loading.segments
        ? _c("segments-navbar-loader")
        : _c("segments-navbar", {
            attrs: {
              segments: _vm.currentList.segments || [],
              "current-tab": _vm.currentTab,
            },
            on: {
              "segment-change": _vm.handleChangeTabRequest,
              "change-name": _vm.handleChangeNameAndSubmit,
            },
          }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "card mortgage mt-sm-0 p-3" },
        [
          _c(
            "div",
            { staticClass: "tab-pane px-2 fade p-0 active show" },
            [
              _vm.currentTab !== "all"
                ? _c("segments-edit", {
                    key: _vm.currentSegment.id + "-" + _vm.listId,
                    attrs: {
                      segments: _vm.segments,
                      "current-segment": _vm.currentSegment,
                      "is-new": _vm.currentTab === "add",
                      "create-segment-loading": _vm.loading.createSegment,
                    },
                    on: {
                      "condition-update": _vm.handleConditionUpdate,
                      "condition-delete": _vm.handleConditionDelete,
                      "condition-add": _vm.handleConditionAdd,
                      "toggle-join": _vm.handleToggleJoin,
                      "change-name": _vm.handleChangeName,
                      submit: _vm.handleFormatSubmit,
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.currentTab !== "add"
                ? _c(
                    "div",
                    [
                      _c("segments-search", {
                        attrs: {
                          "search-string": _vm.currentSearchString,
                          "current-tab": _vm.currentTab,
                        },
                        on: { "search-contacts": _vm.handleSearch },
                      }),
                      _vm._v(" "),
                      _vm.loading.list
                        ? _c("segments-table-loader")
                        : _c("segments-table", {
                            attrs: {
                              list: _vm.list.list || [],
                              segments: _vm.segments,
                              "list-id": _vm.listId,
                              "email-count": _vm.list.emailCount || 0,
                              offset: _vm.list.offset,
                              limit: _vm.list.limit,
                              "current-tab": _vm.currentTab,
                              "order-by": _vm.orderBy,
                              "order-type": _vm.orderType,
                            },
                            on: {
                              "page-change": _vm.handlePageChange,
                              subscribe: _vm.handleSubscribe,
                              "sort-list": _vm.handlePageSort,
                            },
                          }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c("segment-unsaved-changes-modal", {
            ref: "unsavedChangesModalRef",
            on: { confirm: _vm.handleChangeTab },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }